module.exports = __webpack_public_path__ + "static/media/gulecler_socks.eb0655b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/gulecler_socks.jpg
// module id = 621
// module chunks = 0